import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService, Message, SelectItemGroup, SelectItem } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { forkJoin, Observable, of } from 'rxjs';
import { AppBreadcrumbService } from 'src/app/app.breadcrumb.service';
import {utility} from 'src/app/common/utility';
import { ValidateformComponent } from 'src/app/common/validateform/validateform.component';
import { ResourceService } from 'src/app/services/ResourceService';
import { environment } from 'src/environments/environment';
import {EditguarddialogService} from 'src/app/common/guards/editguarddialog.service';
import { flatMap } from 'rxjs/operators';
import { AlertService } from 'src/app/services/AlertService';

class Link {
  Title: string;
  DocumentURI: string;
  FileTypeID: number = 7;
}

@Component({
  selector: 'app-resource-add-edit',
  templateUrl: './resource-add-edit.component.html',
  styleUrls: ['./resource-add-edit.component.scss']
})
export class ResourceAddEditComponent implements OnInit {
  categories: any[];
  resourcecategories: SelectItemGroup[] = [];
  selectedCategoryId: number
  ResourceName: string;
  Description: string;
  Documents: any[] = [];
  Links: Link[] = [];
  link: Link;
  msgs: Message[];
  resourceId: number;
  linkDialog: boolean;
  submitted: boolean;
  resourcetoAddOrUpdate: any;


  isDirty: boolean = false;

  @ViewChild(FileUpload) pFileUpload: FileUpload;
  @ViewChild('f', { static: true }) addResourceForm: NgForm;
  @ViewChild(ValidateformComponent, { static: true })
  private formValidator: ValidateformComponent;

  options: any
  news: any;
  newsTypeOptions: any[] = [];
  messageId: any;
  uploadURL: string = environment.apiBase.concat("Resource/UploadResourceDocuments");


  constructor(private activatedRoute: ActivatedRoute, private breadcrumbService: AppBreadcrumbService, private router: Router,
    private resourceservice: ResourceService, private confirmationService: ConfirmationService,  private editDialogService: EditguarddialogService,
    private alertService: AlertService) { }

  ngOnInit(): void {

    let resource;

    resource = this.activatedRoute.snapshot.data['resource'];
    this.setResource(resource);

    this.categories = this.activatedRoute.snapshot.data['resourcecategories'];
    this.categoriesToNodes(this.categories)

    this.breadcrumbService.setItems([
      { label: 'Resource-Center', routerLink: ['resource-center/view'] }
  ]);
  }

  openNew() {
    this.link = { Title: "", DocumentURI: "", FileTypeID: 7 };
    this.submitted = false;
    this.linkDialog = true;
  }
  hideDialog() {
    this.linkDialog = false;
    this.submitted = false;
  }

  saveLink() {
    this.submitted = true;

    if (this.link.Title.trim()) {

      if (this.link.Title.trim()) {
        this.Links.push(this.link);
      }
      this.Links = [...this.Links];
      this.linkDialog = false;
      this.link = { Title: "", DocumentURI: "", FileTypeID: 7 };
    }
  }
  IsDocuments(): boolean {
    if (this.Documents !== undefined && this.Documents.length != 0) {
      return false;
    }
    return true;
  };

  setResource(resource) {

    this.isDirty = true; 
    if (resource != undefined) {
      this.resourceId = resource.Id;
      this.Documents = resource.Documents;
      this.Description = resource.Description;
      this.ResourceName = resource.Name;
      this.selectedCategoryId = resource.ResourceCategoryID;
      this.resourcetoAddOrUpdate = resource;  

    }
    else
    {
      this.resourcetoAddOrUpdate = {}
    }

  }

  getResource()
  {
    
     this.resourcetoAddOrUpdate.Name = this.ResourceName;
     this.resourcetoAddOrUpdate.Description = this.Description;
     this.resourcetoAddOrUpdate.ResourceCategoryID = this.selectedCategoryId;
     if(this.Documents != undefined)
     {
       this.resourcetoAddOrUpdate.Documents = this.Documents; 
     }
  }
  saveResource() {

   
    if (this.formValidator.validateForm()) {
      this.getResource();
      this.resourceservice.saveResource(this.resourcetoAddOrUpdate).subscribe(
          result => {
              this.setResource(result)
              if (this.pFileUpload.files.length > 0) {
                  this.pFileUpload.upload();
              }
              if(this.Links.length > 0)
              {
                 let linkarray: any[] = [];
                 this.Links.forEach(link => {

                  let lnk: any = {}; 
                  lnk.ResourceId = this.resourceId; 
                  lnk.Title = link.Title; 
                  lnk.URI = link.DocumentURI;                     

                   linkarray.push(this.resourceservice.UploadResourceLink(lnk));

                  
                 });
                 forkJoin(linkarray).subscribe(result => { this.navigatetoCat();});
              }
              this.isDirty = false; 
              this.navigatetoCat();
          },
          error => {
              this.alertService.SetMessage('error', 'There is an error while saving resource');
          }
      );
  }        
   
  };
  navigatetoCat()
  {
    this.router.navigate(['/resource-list/'+ this.selectedCategoryId.toString()]);
  }

  onBeforeUpload(event) {
    if (this.resourceId != undefined && this.resourceId != 0) {
      event.formData.append('ResourceId', this.resourceId);
      event.formData.append('Description', 'Resource Document');
    }
    else {
      event.xhr.abort();
      event.xhr = null;
      event.stopPropogation();
      this.alertService.SetMessage('error', 'There is an error while uploading file');
    }
  }

  onUploadCompleted(event) {
    if (event.originalEvent.ok) {
      this.router.navigate(['']);
    }
    else {
      this.alertService.SetMessage('error', 'There is an error while uploading file');
    }
  }

  cancelAddResource() {
    this.router.navigate(['resource-center/view']);   
  }

  private categoriesToNodes(categories: any[]) {
    for (let cont of categories) {
      this.resourcecategories.push(this.categoryToTreeNode(cont));
    }
  }

  private categoryToTreeNode(cont: any): SelectItemGroup {
    let childcategories: SelectItem[] = [];

    if (cont.ChildCategories !== undefined) {
      for (let c of cont.ChildCategories) {
        childcategories.push(this.childCategoryToTreeNode(c));
      }
    }
    return {
      label: cont.Name,
      items: childcategories,
      value: cont.Id
    };
  }

  private childCategoryToTreeNode(cont: any): SelectItem {
    return {
      label: cont.Name,
      value: cont.Id

    };
  };

  OpenUrl(doc: any) {
   
    var url = this.getDocumentUrl(doc);
    utility.OpenURl(url);
   
  }
  getDocumentUrl(doc: any): string {
    var result;
    if (doc.FileTypeID != 7) {
      result = environment.imageBase.concat('/', doc.DocumentURI);
    }
    else {
      result = doc.DocumentURI
    }

    return result;
  }
  deleteDocument(doc) {
    let index = this.Documents.indexOf(doc);
    this.Documents = this.Documents.filter((val, i) => i != index);

  }
  deleteLink(doc) {
    let index = this.Links.indexOf(doc);
    this.Links = this.Links.filter((val, i) => i != index);

  }
  getIcon(doc):string
  {
    let fileicon = utility.getDocumentIconClass(doc);
    return fileicon;
  }

  canDeactivate(): Observable<boolean> | boolean {

    if (this.isDirty == true) {
      return this.editDialogService.confirm("Discard unsaved changes?", this.confirmationService);      
   }
  return true 
 }
}
